var map = {
	"./Abomasnow_gaussian2.png": 71,
	"./Abra_gaussian2.png": 72,
	"./Absol_gaussian2.png": 73,
	"./Accelgor_gaussian2.png": 74,
	"./Aegislash_gaussian2.png": 75,
	"./Aerodactyl_gaussian2.png": 76,
	"./Aggron_gaussian2.png": 77,
	"./Aipom_gaussian2.png": 78,
	"./Alakazam_gaussian2.png": 79,
	"./Alomomola_gaussian2.png": 80,
	"./Altaria_gaussian2.png": 81,
	"./Amaura_gaussian2.png": 82,
	"./Ambipom_gaussian2.png": 83,
	"./Amoonguss_gaussian2.png": 84,
	"./Ampharos_gaussian2.png": 85,
	"./Anorith_gaussian2.png": 86,
	"./Araquanid_gaussian2.png": 87,
	"./Arbok_gaussian2.png": 88,
	"./Arcanine_gaussian2.png": 89,
	"./Arceus_gaussian2.png": 90,
	"./Archen_gaussian2.png": 91,
	"./Archeops_gaussian2.png": 92,
	"./Ariados_gaussian2.png": 93,
	"./Armaldo_gaussian2.png": 94,
	"./Aromatisse_gaussian2.png": 95,
	"./Aron_gaussian2.png": 96,
	"./Articuno_gaussian2.png": 97,
	"./Audino_gaussian2.png": 98,
	"./Aurorus_gaussian2.png": 99,
	"./Avalugg_gaussian2.png": 100,
	"./Axew_gaussian2.png": 101,
	"./Azelf_gaussian2.png": 102,
	"./Azumarill_gaussian2.png": 103,
	"./Azurill_gaussian2.png": 104,
	"./Bagon_gaussian2.png": 105,
	"./Baltoy_gaussian2.png": 106,
	"./Banette_gaussian2.png": 107,
	"./Barbaracle_gaussian2.png": 108,
	"./Barboach_gaussian2.png": 109,
	"./Basculin_gaussian2.png": 110,
	"./Bastiodon_gaussian2.png": 111,
	"./Bayleef_gaussian2.png": 112,
	"./Beartic_gaussian2.png": 113,
	"./Beautifly_gaussian2.png": 114,
	"./Beedrill_gaussian2.png": 115,
	"./Beheeyem_gaussian2.png": 116,
	"./Beldum_gaussian2.png": 117,
	"./Bellossom_gaussian2.png": 118,
	"./Bellsprout_gaussian2.png": 119,
	"./Bergmite_gaussian2.png": 120,
	"./Bewear_gaussian2.png": 121,
	"./Bibarel_gaussian2.png": 122,
	"./Bidoof_gaussian2.png": 123,
	"./Binacle_gaussian2.png": 124,
	"./Bisharp_gaussian2.png": 125,
	"./Blastoise_gaussian2.png": 126,
	"./Blaziken_gaussian2.png": 127,
	"./Blissey_gaussian2.png": 128,
	"./Blitzle_gaussian2.png": 129,
	"./Boldore_gaussian2.png": 130,
	"./Bonsly_gaussian2.png": 131,
	"./Bouffalant_gaussian2.png": 132,
	"./Bounsweet_gaussian2.png": 133,
	"./Braixen_gaussian2.png": 134,
	"./Braviary_gaussian2.png": 135,
	"./Breloom_gaussian2.png": 136,
	"./Brionne_gaussian2.png": 137,
	"./Bronzong_gaussian2.png": 138,
	"./Bronzor_gaussian2.png": 139,
	"./Bruxish_gaussian2.png": 140,
	"./Budew_gaussian2.png": 141,
	"./Buizel_gaussian2.png": 142,
	"./Bulbasaur_gaussian2.png": 143,
	"./Buneary_gaussian2.png": 144,
	"./Bunnelby_gaussian2.png": 145,
	"./Burmy_gaussian2.png": 146,
	"./Butterfree_gaussian2.png": 147,
	"./Buzzwole_gaussian2.png": 148,
	"./Cacnea_gaussian2.png": 149,
	"./Cacturne_gaussian2.png": 150,
	"./Camerupt_gaussian2.png": 151,
	"./Carbink_gaussian2.png": 152,
	"./Carnivine_gaussian2.png": 153,
	"./Carracosta_gaussian2.png": 154,
	"./Carvanha_gaussian2.png": 155,
	"./Cascoon_gaussian2.png": 156,
	"./Castform_gaussian2.png": 157,
	"./Caterpie_gaussian2.png": 158,
	"./Celebi_gaussian2.png": 159,
	"./Celesteela_gaussian2.png": 160,
	"./Chandelure_gaussian2.png": 161,
	"./Chansey_gaussian2.png": 162,
	"./Charizard_gaussian2.png": 163,
	"./Charjabug_gaussian2.png": 164,
	"./Charmander_gaussian2.png": 165,
	"./Charmeleon_gaussian2.png": 166,
	"./Chatot_gaussian2.png": 167,
	"./Cherrim_gaussian2.png": 168,
	"./Cherubi_gaussian2.png": 169,
	"./Chesnaught_gaussian2.png": 170,
	"./Chespin_gaussian2.png": 171,
	"./Chikorita_gaussian2.png": 172,
	"./Chimchar_gaussian2.png": 173,
	"./Chimecho_gaussian2.png": 174,
	"./Chinchou_gaussian2.png": 175,
	"./Chingling_gaussian2.png": 176,
	"./Cinccino_gaussian2.png": 177,
	"./Clamperl_gaussian2.png": 178,
	"./Clauncher_gaussian2.png": 179,
	"./Clawitzer_gaussian2.png": 180,
	"./Claydol_gaussian2.png": 181,
	"./Clefable_gaussian2.png": 182,
	"./Clefairy_gaussian2.png": 183,
	"./Cleffa_gaussian2.png": 184,
	"./Cloyster_gaussian2.png": 185,
	"./Cobalion_gaussian2.png": 186,
	"./Cofagrigus_gaussian2.png": 187,
	"./Combee_gaussian2.png": 188,
	"./Combusken_gaussian2.png": 189,
	"./Comfey_gaussian2.png": 190,
	"./Conkeldurr_gaussian2.png": 191,
	"./Corphish_gaussian2.png": 192,
	"./Corsola_gaussian2.png": 193,
	"./Cosmoem_gaussian2.png": 194,
	"./Cosmog_gaussian2.png": 195,
	"./Cottonee_gaussian2.png": 196,
	"./Crabominable_gaussian2.png": 197,
	"./Crabrawler_gaussian2.png": 198,
	"./Cradily_gaussian2.png": 199,
	"./Cranidos_gaussian2.png": 200,
	"./Crawdaunt_gaussian2.png": 201,
	"./Cresselia_gaussian2.png": 202,
	"./Croagunk_gaussian2.png": 203,
	"./Crobat_gaussian2.png": 204,
	"./Croconaw_gaussian2.png": 205,
	"./Crustle_gaussian2.png": 206,
	"./Cryogonal_gaussian2.png": 207,
	"./Cubchoo_gaussian2.png": 208,
	"./Cubone_gaussian2.png": 209,
	"./Cutiefly_gaussian2.png": 210,
	"./Cyndaquil_gaussian2.png": 211,
	"./Darkrai_gaussian2.png": 212,
	"./Darmanitan_gaussian2.png": 213,
	"./Dartrix_gaussian2.png": 214,
	"./Darumaka_gaussian2.png": 215,
	"./Decidueye_gaussian2.png": 216,
	"./Dedenne_gaussian2.png": 217,
	"./Deerling_gaussian2.png": 218,
	"./Deino_gaussian2.png": 219,
	"./Delcatty_gaussian2.png": 220,
	"./Delibird_gaussian2.png": 221,
	"./Delphox_gaussian2.png": 222,
	"./Deoxys_gaussian2.png": 223,
	"./Dewgong_gaussian2.png": 224,
	"./Dewott_gaussian2.png": 225,
	"./Dewpider_gaussian2.png": 226,
	"./Dhelmise_gaussian2.png": 227,
	"./Dialga_gaussian2.png": 228,
	"./Diancie_gaussian2.png": 229,
	"./Diggersby_gaussian2.png": 230,
	"./Diglett_gaussian2.png": 231,
	"./Ditto_gaussian2.png": 232,
	"./Dodrio_gaussian2.png": 233,
	"./Doduo_gaussian2.png": 234,
	"./Donphan_gaussian2.png": 235,
	"./Doublade_gaussian2.png": 236,
	"./Dragalge_gaussian2.png": 237,
	"./Dragonair_gaussian2.png": 238,
	"./Dragonite_gaussian2.png": 239,
	"./Drampa_gaussian2.png": 240,
	"./Drapion_gaussian2.png": 241,
	"./Dratini_gaussian2.png": 242,
	"./Drifblim_gaussian2.png": 243,
	"./Drifloon_gaussian2.png": 244,
	"./Drilbur_gaussian2.png": 245,
	"./Drowzee_gaussian2.png": 246,
	"./Druddigon_gaussian2.png": 247,
	"./Ducklett_gaussian2.png": 248,
	"./Dugtrio_gaussian2.png": 249,
	"./Dunsparce_gaussian2.png": 250,
	"./Duosion_gaussian2.png": 251,
	"./Durant_gaussian2.png": 252,
	"./Dusclops_gaussian2.png": 253,
	"./Dusknoir_gaussian2.png": 254,
	"./Duskull_gaussian2.png": 255,
	"./Dustox_gaussian2.png": 256,
	"./Dwebble_gaussian2.png": 257,
	"./Eelektrik_gaussian2.png": 258,
	"./Eelektross_gaussian2.png": 259,
	"./Eevee_gaussian2.png": 260,
	"./Ekans_gaussian2.png": 261,
	"./Electabuzz_gaussian2.png": 262,
	"./Electivire_gaussian2.png": 263,
	"./Electrike_gaussian2.png": 264,
	"./Electrode_gaussian2.png": 265,
	"./Elekid_gaussian2.png": 266,
	"./Elgyem_gaussian2.png": 267,
	"./Emboar_gaussian2.png": 268,
	"./Emolga_gaussian2.png": 269,
	"./Empoleon_gaussian2.png": 270,
	"./Entei_gaussian2.png": 271,
	"./Escavalier_gaussian2.png": 272,
	"./Espeon_gaussian2.png": 273,
	"./Espurr_gaussian2.png": 274,
	"./Excadrill_gaussian2.png": 275,
	"./Exeggcute_gaussian2.png": 276,
	"./Exeggutor_gaussian2.png": 277,
	"./Exploud_gaussian2.png": 278,
	"./Farfetch'd_gaussian2.png": 279,
	"./Fearow_gaussian2.png": 280,
	"./Feebas_gaussian2.png": 281,
	"./Fennekin_gaussian2.png": 282,
	"./Feraligatr_gaussian2.png": 283,
	"./Ferroseed_gaussian2.png": 284,
	"./Ferrothorn_gaussian2.png": 285,
	"./Finneon_gaussian2.png": 286,
	"./Flaaffy_gaussian2.png": 287,
	"./Flabébé_gaussian2.png": 288,
	"./Flareon_gaussian2.png": 289,
	"./Fletchinder_gaussian2.png": 290,
	"./Fletchling_gaussian2.png": 291,
	"./Floatzel_gaussian2.png": 292,
	"./Floette_gaussian2.png": 293,
	"./Florges_gaussian2.png": 294,
	"./Flygon_gaussian2.png": 295,
	"./Fomantis_gaussian2.png": 296,
	"./Foongus_gaussian2.png": 297,
	"./Forretress_gaussian2.png": 298,
	"./Fraxure_gaussian2.png": 299,
	"./Frillish_gaussian2.png": 300,
	"./Froakie_gaussian2.png": 301,
	"./Frogadier_gaussian2.png": 302,
	"./Froslass_gaussian2.png": 303,
	"./Furfrou_gaussian2.png": 304,
	"./Furret_gaussian2.png": 305,
	"./Gabite_gaussian2.png": 306,
	"./Gallade_gaussian2.png": 307,
	"./Galvantula_gaussian2.png": 308,
	"./Garbodor_gaussian2.png": 309,
	"./Garchomp_gaussian2.png": 310,
	"./Gardevoir_gaussian2.png": 311,
	"./Gastly_gaussian2.png": 312,
	"./Gastrodon_gaussian2.png": 313,
	"./Genesect_gaussian2.png": 314,
	"./Gengar_gaussian2.png": 315,
	"./Geodude_gaussian2.png": 316,
	"./Gible_gaussian2.png": 317,
	"./Gigalith_gaussian2.png": 318,
	"./Girafarig_gaussian2.png": 319,
	"./Giratina_gaussian2.png": 320,
	"./Glaceon_gaussian2.png": 321,
	"./Glalie_gaussian2.png": 322,
	"./Glameow_gaussian2.png": 323,
	"./Gligar_gaussian2.png": 324,
	"./Gliscor_gaussian2.png": 325,
	"./Gloom_gaussian2.png": 326,
	"./Gogoat_gaussian2.png": 327,
	"./Golbat_gaussian2.png": 328,
	"./Goldeen_gaussian2.png": 329,
	"./Golduck_gaussian2.png": 330,
	"./Golem_gaussian2.png": 331,
	"./Golett_gaussian2.png": 332,
	"./Golisopod_gaussian2.png": 333,
	"./Golurk_gaussian2.png": 334,
	"./Goodra_gaussian2.png": 335,
	"./Goomy_gaussian2.png": 336,
	"./Gorebyss_gaussian2.png": 337,
	"./Gothita_gaussian2.png": 338,
	"./Gothitelle_gaussian2.png": 339,
	"./Gothorita_gaussian2.png": 340,
	"./Gourgeist_gaussian2.png": 341,
	"./Granbull_gaussian2.png": 342,
	"./Graveler_gaussian2.png": 343,
	"./Greninja_gaussian2.png": 344,
	"./Grimer_gaussian2.png": 345,
	"./Grotle_gaussian2.png": 346,
	"./Groudon_gaussian2.png": 347,
	"./Grovyle_gaussian2.png": 348,
	"./Growlithe_gaussian2.png": 349,
	"./Grubbin_gaussian2.png": 350,
	"./Grumpig_gaussian2.png": 351,
	"./Gulpin_gaussian2.png": 352,
	"./Gumshoos_gaussian2.png": 353,
	"./Gurdurr_gaussian2.png": 354,
	"./Guzzlord_gaussian2.png": 355,
	"./Gyarados_gaussian2.png": 356,
	"./Hakamo-o_gaussian2.png": 357,
	"./Happiny_gaussian2.png": 358,
	"./Hariyama_gaussian2.png": 359,
	"./Haunter_gaussian2.png": 360,
	"./Hawlucha_gaussian2.png": 361,
	"./Haxorus_gaussian2.png": 362,
	"./Heatmor_gaussian2.png": 363,
	"./Heatran_gaussian2.png": 364,
	"./Heliolisk_gaussian2.png": 365,
	"./Helioptile_gaussian2.png": 366,
	"./Heracross_gaussian2.png": 367,
	"./Herdier_gaussian2.png": 368,
	"./Hippopotas_gaussian2.png": 369,
	"./Hippowdon_gaussian2.png": 370,
	"./Hitmonchan_gaussian2.png": 371,
	"./Hitmonlee_gaussian2.png": 372,
	"./Hitmontop_gaussian2.png": 373,
	"./Ho-Oh_gaussian2.png": 374,
	"./Honchkrow_gaussian2.png": 375,
	"./Honedge_gaussian2.png": 376,
	"./Hoopa_gaussian2.png": 377,
	"./Hoothoot_gaussian2.png": 378,
	"./Hoppip_gaussian2.png": 379,
	"./Horsea_gaussian2.png": 380,
	"./Houndoom_gaussian2.png": 381,
	"./Houndour_gaussian2.png": 382,
	"./Huntail_gaussian2.png": 383,
	"./Hydreigon_gaussian2.png": 384,
	"./Hypno_gaussian2.png": 385,
	"./Igglybuff_gaussian2.png": 386,
	"./Illumise_gaussian2.png": 387,
	"./Incineroar_gaussian2.png": 388,
	"./Infernape_gaussian2.png": 389,
	"./Inkay_gaussian2.png": 390,
	"./Ivysaur_gaussian2.png": 391,
	"./Jangmo-o_gaussian2.png": 392,
	"./Jellicent_gaussian2.png": 393,
	"./Jigglypuff_gaussian2.png": 394,
	"./Jirachi_gaussian2.png": 395,
	"./Jolteon_gaussian2.png": 396,
	"./Joltik_gaussian2.png": 397,
	"./Jumpluff_gaussian2.png": 398,
	"./Jynx_gaussian2.png": 399,
	"./Kabuto_gaussian2.png": 400,
	"./Kabutops_gaussian2.png": 401,
	"./Kadabra_gaussian2.png": 402,
	"./Kakuna_gaussian2.png": 403,
	"./Kangaskhan_gaussian2.png": 404,
	"./Karrablast_gaussian2.png": 405,
	"./Kartana_gaussian2.png": 406,
	"./Kecleon_gaussian2.png": 407,
	"./Keldeo_gaussian2.png": 408,
	"./Kingdra_gaussian2.png": 409,
	"./Kingler_gaussian2.png": 410,
	"./Kirlia_gaussian2.png": 411,
	"./Klang_gaussian2.png": 412,
	"./Klefki_gaussian2.png": 413,
	"./Klink_gaussian2.png": 414,
	"./Klinklang_gaussian2.png": 415,
	"./Koffing_gaussian2.png": 416,
	"./Komala_gaussian2.png": 417,
	"./Kommo-o_gaussian2.png": 418,
	"./Krabby_gaussian2.png": 419,
	"./Kricketot_gaussian2.png": 420,
	"./Kricketune_gaussian2.png": 421,
	"./Krokorok_gaussian2.png": 422,
	"./Krookodile_gaussian2.png": 423,
	"./Kyogre_gaussian2.png": 424,
	"./Kyurem_gaussian2.png": 425,
	"./Lairon_gaussian2.png": 426,
	"./Lampent_gaussian2.png": 427,
	"./Landorus_gaussian2.png": 428,
	"./Lanturn_gaussian2.png": 429,
	"./Lapras_gaussian2.png": 430,
	"./Larvesta_gaussian2.png": 431,
	"./Larvitar_gaussian2.png": 432,
	"./Latias_gaussian2.png": 433,
	"./Latios_gaussian2.png": 434,
	"./Leafeon_gaussian2.png": 435,
	"./Leavanny_gaussian2.png": 436,
	"./Ledian_gaussian2.png": 437,
	"./Ledyba_gaussian2.png": 438,
	"./Lickilicky_gaussian2.png": 439,
	"./Lickitung_gaussian2.png": 440,
	"./Liepard_gaussian2.png": 441,
	"./Lileep_gaussian2.png": 442,
	"./Lilligant_gaussian2.png": 443,
	"./Lillipup_gaussian2.png": 444,
	"./Linoone_gaussian2.png": 445,
	"./Litleo_gaussian2.png": 446,
	"./Litten_gaussian2.png": 447,
	"./Litwick_gaussian2.png": 448,
	"./Lombre_gaussian2.png": 449,
	"./Lopunny_gaussian2.png": 450,
	"./Lotad_gaussian2.png": 451,
	"./Loudred_gaussian2.png": 452,
	"./Lucario_gaussian2.png": 453,
	"./Ludicolo_gaussian2.png": 454,
	"./Lugia_gaussian2.png": 455,
	"./Lumineon_gaussian2.png": 456,
	"./Lunala_gaussian2.png": 457,
	"./Lunatone_gaussian2.png": 458,
	"./Lurantis_gaussian2.png": 459,
	"./Luvdisc_gaussian2.png": 460,
	"./Luxio_gaussian2.png": 461,
	"./Luxray_gaussian2.png": 462,
	"./Lycanroc_gaussian2.png": 463,
	"./Machamp_gaussian2.png": 464,
	"./Machoke_gaussian2.png": 465,
	"./Machop_gaussian2.png": 466,
	"./Magby_gaussian2.png": 467,
	"./Magcargo_gaussian2.png": 468,
	"./Magearna_gaussian2.png": 469,
	"./Magikarp_gaussian2.png": 470,
	"./Magmar_gaussian2.png": 471,
	"./Magmortar_gaussian2.png": 472,
	"./Magnemite_gaussian2.png": 473,
	"./Magneton_gaussian2.png": 474,
	"./Magnezone_gaussian2.png": 475,
	"./Makuhita_gaussian2.png": 476,
	"./Malamar_gaussian2.png": 477,
	"./Mamoswine_gaussian2.png": 478,
	"./Manaphy_gaussian2.png": 479,
	"./Mandibuzz_gaussian2.png": 480,
	"./Manectric_gaussian2.png": 481,
	"./Mankey_gaussian2.png": 482,
	"./Mantine_gaussian2.png": 483,
	"./Mantyke_gaussian2.png": 484,
	"./Maractus_gaussian2.png": 485,
	"./Mareanie_gaussian2.png": 486,
	"./Mareep_gaussian2.png": 487,
	"./Marill_gaussian2.png": 488,
	"./Marowak_gaussian2.png": 489,
	"./Marshtomp_gaussian2.png": 490,
	"./Masquerain_gaussian2.png": 491,
	"./Mawile_gaussian2.png": 492,
	"./Medicham_gaussian2.png": 493,
	"./Meditite_gaussian2.png": 494,
	"./Meganium_gaussian2.png": 495,
	"./Meloetta_gaussian2.png": 496,
	"./Meowstic_gaussian2.png": 497,
	"./Meowth_gaussian2.png": 498,
	"./Mesprit_gaussian2.png": 499,
	"./Metagross_gaussian2.png": 500,
	"./Metang_gaussian2.png": 501,
	"./Metapod_gaussian2.png": 502,
	"./Mew_gaussian2.png": 503,
	"./Mewtwo_gaussian2.png": 504,
	"./Mienfoo_gaussian2.png": 505,
	"./Mienshao_gaussian2.png": 506,
	"./Mightyena_gaussian2.png": 507,
	"./Milotic_gaussian2.png": 508,
	"./Miltank_gaussian2.png": 509,
	"./Mime_Jr._gaussian2.png": 510,
	"./Mimikyu_gaussian2.png": 511,
	"./Minccino_gaussian2.png": 512,
	"./Minior_gaussian2.png": 513,
	"./Minun_gaussian2.png": 514,
	"./Misdreavus_gaussian2.png": 515,
	"./Mismagius_gaussian2.png": 516,
	"./Moltres_gaussian2.png": 517,
	"./Monferno_gaussian2.png": 518,
	"./Morelull_gaussian2.png": 519,
	"./Mothim_gaussian2.png": 520,
	"./Mr._Mime_gaussian2.png": 521,
	"./Mudbray_gaussian2.png": 522,
	"./Mudkip_gaussian2.png": 523,
	"./Mudsdale_gaussian2.png": 524,
	"./Muk_gaussian2.png": 525,
	"./Munchlax_gaussian2.png": 526,
	"./Munna_gaussian2.png": 527,
	"./Murkrow_gaussian2.png": 528,
	"./Musharna_gaussian2.png": 529,
	"./Natu_gaussian2.png": 530,
	"./Necrozma_gaussian2.png": 531,
	"./Nidoking_gaussian2.png": 532,
	"./Nidoqueen_gaussian2.png": 533,
	"./Nidoran♀_gaussian2.png": 534,
	"./Nidoran♂_gaussian2.png": 535,
	"./Nidorina_gaussian2.png": 536,
	"./Nidorino_gaussian2.png": 537,
	"./Nihilego_gaussian2.png": 538,
	"./Nincada_gaussian2.png": 539,
	"./Ninetales_gaussian2.png": 540,
	"./Ninjask_gaussian2.png": 541,
	"./Noctowl_gaussian2.png": 542,
	"./Noibat_gaussian2.png": 543,
	"./Noivern_gaussian2.png": 544,
	"./Nosepass_gaussian2.png": 545,
	"./Numel_gaussian2.png": 546,
	"./Nuzleaf_gaussian2.png": 547,
	"./Octillery_gaussian2.png": 548,
	"./Oddish_gaussian2.png": 549,
	"./Omanyte_gaussian2.png": 550,
	"./Omastar_gaussian2.png": 551,
	"./Onix_gaussian2.png": 552,
	"./Oranguru_gaussian2.png": 553,
	"./Oricorio_gaussian2.png": 554,
	"./Oshawott_gaussian2.png": 555,
	"./Pachirisu_gaussian2.png": 556,
	"./Palkia_gaussian2.png": 557,
	"./Palossand_gaussian2.png": 558,
	"./Palpitoad_gaussian2.png": 559,
	"./Pancham_gaussian2.png": 560,
	"./Pangoro_gaussian2.png": 561,
	"./Panpour_gaussian2.png": 562,
	"./Pansage_gaussian2.png": 563,
	"./Pansear_gaussian2.png": 564,
	"./Paras_gaussian2.png": 565,
	"./Parasect_gaussian2.png": 566,
	"./Passimian_gaussian2.png": 567,
	"./Patrat_gaussian2.png": 568,
	"./Pawniard_gaussian2.png": 569,
	"./Pelipper_gaussian2.png": 570,
	"./Persian_gaussian2.png": 571,
	"./Petilil_gaussian2.png": 572,
	"./Phanpy_gaussian2.png": 573,
	"./Phantump_gaussian2.png": 574,
	"./Pheromosa_gaussian2.png": 575,
	"./Phione_gaussian2.png": 576,
	"./Pichu_gaussian2.png": 577,
	"./Pidgeot_gaussian2.png": 578,
	"./Pidgeotto_gaussian2.png": 579,
	"./Pidgey_gaussian2.png": 580,
	"./Pidove_gaussian2.png": 581,
	"./Pignite_gaussian2.png": 582,
	"./Pikachu_gaussian2.png": 583,
	"./Pikipek_gaussian2.png": 584,
	"./Piloswine_gaussian2.png": 585,
	"./Pineco_gaussian2.png": 586,
	"./Pinsir_gaussian2.png": 587,
	"./Piplup_gaussian2.png": 588,
	"./Plusle_gaussian2.png": 589,
	"./Politoed_gaussian2.png": 590,
	"./Poliwag_gaussian2.png": 591,
	"./Poliwhirl_gaussian2.png": 592,
	"./Poliwrath_gaussian2.png": 593,
	"./Ponyta_gaussian2.png": 594,
	"./Poochyena_gaussian2.png": 595,
	"./Popplio_gaussian2.png": 596,
	"./Porygon-Z_gaussian2.png": 597,
	"./Porygon2_gaussian2.png": 598,
	"./Porygon_gaussian2.png": 599,
	"./Primarina_gaussian2.png": 600,
	"./Primeape_gaussian2.png": 601,
	"./Prinplup_gaussian2.png": 602,
	"./Probopass_gaussian2.png": 603,
	"./Psyduck_gaussian2.png": 604,
	"./Pumpkaboo_gaussian2.png": 605,
	"./Pupitar_gaussian2.png": 606,
	"./Purrloin_gaussian2.png": 607,
	"./Purugly_gaussian2.png": 608,
	"./Pyroar_gaussian2.png": 609,
	"./Pyukumuku_gaussian2.png": 610,
	"./Quagsire_gaussian2.png": 611,
	"./Quilava_gaussian2.png": 612,
	"./Quilladin_gaussian2.png": 613,
	"./Qwilfish_gaussian2.png": 614,
	"./Raichu_gaussian2.png": 615,
	"./Raikou_gaussian2.png": 616,
	"./Ralts_gaussian2.png": 617,
	"./Rampardos_gaussian2.png": 618,
	"./Rapidash_gaussian2.png": 619,
	"./Raticate_gaussian2.png": 620,
	"./Rattata_gaussian2.png": 621,
	"./Rayquaza_gaussian2.png": 622,
	"./Regice_gaussian2.png": 623,
	"./Regigigas_gaussian2.png": 624,
	"./Regirock_gaussian2.png": 625,
	"./Registeel_gaussian2.png": 626,
	"./Relicanth_gaussian2.png": 627,
	"./Remoraid_gaussian2.png": 628,
	"./Reshiram_gaussian2.png": 629,
	"./Reuniclus_gaussian2.png": 630,
	"./Rhydon_gaussian2.png": 631,
	"./Rhyhorn_gaussian2.png": 632,
	"./Rhyperior_gaussian2.png": 633,
	"./Ribombee_gaussian2.png": 634,
	"./Riolu_gaussian2.png": 635,
	"./Rockruff_gaussian2.png": 636,
	"./Roggenrola_gaussian2.png": 637,
	"./Roselia_gaussian2.png": 638,
	"./Roserade_gaussian2.png": 639,
	"./Rotom_gaussian2.png": 640,
	"./Rowlet_gaussian2.png": 641,
	"./Rufflet_gaussian2.png": 642,
	"./Sableye_gaussian2.png": 643,
	"./Salamence_gaussian2.png": 644,
	"./Salandit_gaussian2.png": 645,
	"./Salazzle_gaussian2.png": 646,
	"./Samurott_gaussian2.png": 647,
	"./Sandile_gaussian2.png": 648,
	"./Sandshrew_gaussian2.png": 649,
	"./Sandslash_gaussian2.png": 650,
	"./Sandygast_gaussian2.png": 651,
	"./Sawk_gaussian2.png": 652,
	"./Sawsbuck_gaussian2.png": 653,
	"./Scatterbug_gaussian2.png": 654,
	"./Sceptile_gaussian2.png": 655,
	"./Scizor_gaussian2.png": 656,
	"./Scolipede_gaussian2.png": 657,
	"./Scrafty_gaussian2.png": 658,
	"./Scraggy_gaussian2.png": 659,
	"./Scyther_gaussian2.png": 660,
	"./Seadra_gaussian2.png": 661,
	"./Seaking_gaussian2.png": 662,
	"./Sealeo_gaussian2.png": 663,
	"./Seedot_gaussian2.png": 664,
	"./Seel_gaussian2.png": 665,
	"./Seismitoad_gaussian2.png": 666,
	"./Sentret_gaussian2.png": 667,
	"./Serperior_gaussian2.png": 668,
	"./Servine_gaussian2.png": 669,
	"./Seviper_gaussian2.png": 670,
	"./Sewaddle_gaussian2.png": 671,
	"./Sharpedo_gaussian2.png": 672,
	"./Shaymin_gaussian2.png": 673,
	"./Shedinja_gaussian2.png": 674,
	"./Shelgon_gaussian2.png": 675,
	"./Shellder_gaussian2.png": 676,
	"./Shellos_gaussian2.png": 677,
	"./Shelmet_gaussian2.png": 678,
	"./Shieldon_gaussian2.png": 679,
	"./Shiftry_gaussian2.png": 680,
	"./Shiinotic_gaussian2.png": 681,
	"./Shinx_gaussian2.png": 682,
	"./Shroomish_gaussian2.png": 683,
	"./Shuckle_gaussian2.png": 684,
	"./Shuppet_gaussian2.png": 685,
	"./Sigilyph_gaussian2.png": 686,
	"./Silcoon_gaussian2.png": 687,
	"./Silvally_gaussian2.png": 688,
	"./Simipour_gaussian2.png": 689,
	"./Simisage_gaussian2.png": 690,
	"./Simisear_gaussian2.png": 691,
	"./Skarmory_gaussian2.png": 692,
	"./Skiddo_gaussian2.png": 693,
	"./Skiploom_gaussian2.png": 694,
	"./Skitty_gaussian2.png": 695,
	"./Skorupi_gaussian2.png": 696,
	"./Skrelp_gaussian2.png": 697,
	"./Skuntank_gaussian2.png": 698,
	"./Slaking_gaussian2.png": 699,
	"./Slakoth_gaussian2.png": 700,
	"./Sliggoo_gaussian2.png": 701,
	"./Slowbro_gaussian2.png": 702,
	"./Slowking_gaussian2.png": 703,
	"./Slowpoke_gaussian2.png": 704,
	"./Slugma_gaussian2.png": 705,
	"./Slurpuff_gaussian2.png": 706,
	"./Smeargle_gaussian2.png": 707,
	"./Smoochum_gaussian2.png": 708,
	"./Sneasel_gaussian2.png": 709,
	"./Snivy_gaussian2.png": 710,
	"./Snorlax_gaussian2.png": 711,
	"./Snorunt_gaussian2.png": 712,
	"./Snover_gaussian2.png": 713,
	"./Snubbull_gaussian2.png": 714,
	"./Solgaleo_gaussian2.png": 715,
	"./Solosis_gaussian2.png": 716,
	"./Solrock_gaussian2.png": 717,
	"./Spearow_gaussian2.png": 718,
	"./Spewpa_gaussian2.png": 719,
	"./Spheal_gaussian2.png": 720,
	"./Spinarak_gaussian2.png": 721,
	"./Spinda_gaussian2.png": 722,
	"./Spiritomb_gaussian2.png": 723,
	"./Spoink_gaussian2.png": 724,
	"./Spritzee_gaussian2.png": 725,
	"./Squirtle_gaussian2.png": 726,
	"./Stantler_gaussian2.png": 727,
	"./Staraptor_gaussian2.png": 728,
	"./Staravia_gaussian2.png": 729,
	"./Starly_gaussian2.png": 730,
	"./Starmie_gaussian2.png": 731,
	"./Staryu_gaussian2.png": 732,
	"./Steelix_gaussian2.png": 733,
	"./Steenee_gaussian2.png": 734,
	"./Stoutland_gaussian2.png": 735,
	"./Stufful_gaussian2.png": 736,
	"./Stunfisk_gaussian2.png": 737,
	"./Stunky_gaussian2.png": 738,
	"./Sudowoodo_gaussian2.png": 739,
	"./Suicune_gaussian2.png": 740,
	"./Sunflora_gaussian2.png": 741,
	"./Sunkern_gaussian2.png": 742,
	"./Surskit_gaussian2.png": 743,
	"./Swablu_gaussian2.png": 744,
	"./Swadloon_gaussian2.png": 745,
	"./Swalot_gaussian2.png": 746,
	"./Swampert_gaussian2.png": 747,
	"./Swanna_gaussian2.png": 748,
	"./Swellow_gaussian2.png": 749,
	"./Swinub_gaussian2.png": 750,
	"./Swirlix_gaussian2.png": 751,
	"./Swoobat_gaussian2.png": 752,
	"./Sylveon_gaussian2.png": 753,
	"./Taillow_gaussian2.png": 754,
	"./Talonflame_gaussian2.png": 755,
	"./Tangela_gaussian2.png": 756,
	"./Tangrowth_gaussian2.png": 757,
	"./Tapu Bulu_gaussian2.png": 758,
	"./Tapu Fini_gaussian2.png": 759,
	"./Tapu Koko_gaussian2.png": 760,
	"./Tapu Lele_gaussian2.png": 761,
	"./Tauros_gaussian2.png": 762,
	"./Teddiursa_gaussian2.png": 763,
	"./Tentacool_gaussian2.png": 764,
	"./Tentacruel_gaussian2.png": 765,
	"./Tepig_gaussian2.png": 766,
	"./Terrakion_gaussian2.png": 767,
	"./Throh_gaussian2.png": 768,
	"./Thundurus_gaussian2.png": 769,
	"./Timburr_gaussian2.png": 770,
	"./Tirtouga_gaussian2.png": 771,
	"./Togedemaru_gaussian2.png": 772,
	"./Togekiss_gaussian2.png": 773,
	"./Togepi_gaussian2.png": 774,
	"./Togetic_gaussian2.png": 775,
	"./Torchic_gaussian2.png": 776,
	"./Torkoal_gaussian2.png": 777,
	"./Tornadus_gaussian2.png": 778,
	"./Torracat_gaussian2.png": 779,
	"./Torterra_gaussian2.png": 780,
	"./Totodile_gaussian2.png": 781,
	"./Toucannon_gaussian2.png": 782,
	"./Toxapex_gaussian2.png": 783,
	"./Toxicroak_gaussian2.png": 784,
	"./Tranquill_gaussian2.png": 785,
	"./Trapinch_gaussian2.png": 786,
	"./Treecko_gaussian2.png": 787,
	"./Trevenant_gaussian2.png": 788,
	"./Tropius_gaussian2.png": 789,
	"./Trubbish_gaussian2.png": 790,
	"./Trumbeak_gaussian2.png": 791,
	"./Tsareena_gaussian2.png": 792,
	"./Turtonator_gaussian2.png": 793,
	"./Turtwig_gaussian2.png": 794,
	"./Tympole_gaussian2.png": 795,
	"./Tynamo_gaussian2.png": 796,
	"./Type_Null_gaussian2.png": 797,
	"./Typhlosion_gaussian2.png": 798,
	"./Tyranitar_gaussian2.png": 799,
	"./Tyrantrum_gaussian2.png": 800,
	"./Tyrogue_gaussian2.png": 801,
	"./Tyrunt_gaussian2.png": 802,
	"./Umbreon_gaussian2.png": 803,
	"./Unfezant_gaussian2.png": 804,
	"./Unown_gaussian2.png": 805,
	"./Ursaring_gaussian2.png": 806,
	"./Uxie_gaussian2.png": 807,
	"./Vanillish_gaussian2.png": 808,
	"./Vanillite_gaussian2.png": 809,
	"./Vanilluxe_gaussian2.png": 810,
	"./Vaporeon_gaussian2.png": 811,
	"./Venipede_gaussian2.png": 812,
	"./Venomoth_gaussian2.png": 813,
	"./Venonat_gaussian2.png": 814,
	"./Venusaur_gaussian2.png": 815,
	"./Vespiquen_gaussian2.png": 816,
	"./Vibrava_gaussian2.png": 817,
	"./Victini_gaussian2.png": 818,
	"./Victreebel_gaussian2.png": 819,
	"./Vigoroth_gaussian2.png": 820,
	"./Vikavolt_gaussian2.png": 821,
	"./Vileplume_gaussian2.png": 822,
	"./Virizion_gaussian2.png": 823,
	"./Vivillon_gaussian2.png": 824,
	"./Volbeat_gaussian2.png": 825,
	"./Volcanion_gaussian2.png": 826,
	"./Volcarona_gaussian2.png": 827,
	"./Voltorb_gaussian2.png": 828,
	"./Vullaby_gaussian2.png": 829,
	"./Vulpix_gaussian2.png": 830,
	"./Wailmer_gaussian2.png": 831,
	"./Wailord_gaussian2.png": 832,
	"./Walrein_gaussian2.png": 833,
	"./Wartortle_gaussian2.png": 834,
	"./Watchog_gaussian2.png": 835,
	"./Weavile_gaussian2.png": 836,
	"./Weedle_gaussian2.png": 837,
	"./Weepinbell_gaussian2.png": 838,
	"./Weezing_gaussian2.png": 839,
	"./Whimsicott_gaussian2.png": 840,
	"./Whirlipede_gaussian2.png": 841,
	"./Whiscash_gaussian2.png": 842,
	"./Whismur_gaussian2.png": 843,
	"./Wigglytuff_gaussian2.png": 844,
	"./Wimpod_gaussian2.png": 845,
	"./Wingull_gaussian2.png": 846,
	"./Wishiwashi_gaussian2.png": 847,
	"./Wobbuffet_gaussian2.png": 848,
	"./Woobat_gaussian2.png": 849,
	"./Wooper_gaussian2.png": 850,
	"./Wormadam_gaussian2.png": 851,
	"./Wurmple_gaussian2.png": 852,
	"./Wynaut_gaussian2.png": 853,
	"./Xatu_gaussian2.png": 854,
	"./Xerneas_gaussian2.png": 855,
	"./Xurkitree_gaussian2.png": 856,
	"./Yamask_gaussian2.png": 857,
	"./Yanma_gaussian2.png": 858,
	"./Yanmega_gaussian2.png": 859,
	"./Yungoos_gaussian2.png": 860,
	"./Yveltal_gaussian2.png": 861,
	"./Zangoose_gaussian2.png": 862,
	"./Zapdos_gaussian2.png": 863,
	"./Zebstrika_gaussian2.png": 864,
	"./Zekrom_gaussian2.png": 865,
	"./Zigzagoon_gaussian2.png": 866,
	"./Zoroark_gaussian2.png": 867,
	"./Zorua_gaussian2.png": 868,
	"./Zubat_gaussian2.png": 869,
	"./Zweilous_gaussian2.png": 870,
	"./Zygarde_gaussian2.png": 871
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70;